module.exports = __webpack_public_path__ + "static/media/lekse.0d1003a2.mp3";